// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__e8_36","prefix":"styles_prefix__OW89V","postfix":"styles_postfix___vj34"};